/** DEVELOPER_UNIT is the numbered-apartment model (מכר יזם); the rest are general-sale (מכר כללי) types. */
export enum AssetType {
  DEVELOPER_UNIT = 'developer_unit',
  APARTMENT = 'apartment',
  PENTHOUSE = 'penthouse',
  GARDEN_APARTMENT = 'garden_apartment',
  DUPLEX = 'duplex',
  STUDIO = 'studio',
  HOUSE = 'house',
  COTTAGE = 'cottage',
  VILLA = 'villa',
  BUILDING = 'building',
  LAND = 'land',
  LOT = 'lot',
  COMMERCIAL = 'commercial',
  OFFICE = 'office',
  STORE = 'store',
  INDUSTRIAL = 'industrial',
  WAREHOUSE = 'warehouse',
  PARKING = 'parking',
  STORAGE = 'storage',
  OTHER = 'other'
}
